<template>
    <PageLayout :has-buttons="false" :has-title="false" id="Home_Health_Edit_Patient" content-class="p-0">
        <template #content>
            <template v-if="isLoadError || isFormLoading || isSaveInProgress">
                <section class="card w-100 h-100 d-flex flex-column align-items-center justify-content-center">
                    <div class="d-flex flex-column align-items-start" v-if="isLoadError && !isFormLoading">
                        <h5 class="fw-bold">Error</h5>
                        <p class="font-size-xl mb-1">
                            <template v-if="referralId">
                                There was problem while loading the referral. Please try again.
                            </template>
                            <template v-else>
                                There was problem while generating the referral form. Please try again.
                            </template>
                        </p>
                        <span class="mb-2"> </span>
                        <button class="btn btn-primary" @click="loadReferral()">Try Again</button>
                    </div>
                    <template v-if="isFormLoading && !isLoadError">
                        <i class="fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2"></i>
                        <span class="font-size-xl">Loading Referral Form...</span>
                    </template>
                    <div v-if="isSaveInProgress" class="d-flex flex-column align-items-center">
                        <i class="far fa-save fa-7x text-primary animated flash infinite slow mb-2"></i>
                        <span class="font-size-xl text-center">Saving Referral...</span>
                    </div>
                </section>
            </template>
            <template v-if="!isLoadError && !isFormLoading && !isSaveInProgress">
                <TabsLayout
                    :header="`Edit Home Health Referral-${formatName(
                        referral.Demographics.FirstName,
                        referral.Demographics.LastName
                    )}`"
                    :tabs="tabs"
                    :activeTab="activeTab"
                    :handleTabChange="handleTabChange"
                    :showErrors="(tab: any) => getNumberOfErrors(tab.name) > 0"
                    :numberOfErrors="(tab: any) => getNumberOfErrors(tab.name)"
                    :showWarnings="
                        (tab: any) =>
                            (getNumberOfWarnings(tab.name) > 0 && allErrors.includes(tab.id)) ||
                            (getNumberOfWarnings(tab.name) > 0 && previousTabs.includes(tab.id))
                    "
                    :showSuccess="
                        (tab: any) =>
                            (getNumberOfWarnings(tab.name) === 0 &&
                                getNumberOfErrors(tab.name) === 0 &&
                                allErrors.includes(tab.id)) ||
                            (getNumberOfWarnings(tab.name) === 0 &&
                                getNumberOfErrors(tab.name) === 0 &&
                                previousTabs.includes(tab.id))
                    "
                    :numberOfWarnings="(tab: any) => getNumberOfWarnings(tab.name)"
                >
                    <template #forms>
                        <section class="container-fluid my-2">
                            <ReferralDemographics
                                :branch-id="branchId"
                                :is-editing="!isCreate"
                                v-on:changeBranchId="changeBranchId"
                                v-on:isSSNDuplicate="isSSNDuplicate"
                                v-show="activeTab === 1"
                            />
                            <div v-show="activeTab === 2">
                                <ReferralPayers />
                            </div>
                            <div v-show="activeTab === 3">
                                <ReferralPhysicians />
                            </div>
                            <div v-show="activeTab === 4">
                                <ClinicalDiagnosis />
                            </div>
                            <div v-show="activeTab === 5">
                                <ReferralPharmacy />
                            </div>
                            <div v-show="activeTab === 6">
                                <ReferralContacts />
                            </div>
                            <div v-show="activeTab === 7">
                                <EmergencyPreparedness />
                            </div>
                            <div v-show="activeTab === 8">
                                <AdvanceDirectives />
                            </div>
                            <div v-show="activeTab === 9">
                                <ReferralInformation />
                            </div>
                        </section>
                    </template>
                    <template #buttons v-if="!isLoadError && !isFormLoading && !isSaveInProgress">
                        <div class="d-flex justify-content-center mt-2 hh-button-container py-2">
                            <div>
                                <button
                                    type="button"
                                    class="btn btn-primary me-2"
                                    @click="handlePatientConversion('reAdmit')"
                                >
                                    Admit
                                </button>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    class="btn btn-primary me-2"
                                    @click="handlePatientConversion('covtToPending')"
                                >
                                    Convert to Pending
                                </button>
                            </div>
                            <button
                                type="button"
                                class="btn btn-primary me-2"
                                @click="update('save-and-continue')"
                                v-if="activeTab !== 9"
                            >
                                Save and Continue
                            </button>
                            <button type="button" class="btn btn-primary me-2" @click="update('save-and-exit')">
                                Save and Exit
                            </button>
                            <button type="button" class="btn btn-outline-primary" @click="handleCancel()">
                                Cancel
                            </button>
                        </div>
                    </template>
                </TabsLayout>
            </template>
        </template>
    </PageLayout>
</template>

<script lang="ts" src="./EditReferralHomeHealth.ts"></script>
<style src="./EditReferralHomeHealth.scss"></style>
